export interface ServiceConfig {
  id: string;
  source: string;
  name: string;
  subtitle: string;
  welcomeMessage: string;
}

const services: Record<string, ServiceConfig> = {
  qq: {
    id: 'qq',
    source: 'quickquote',
    name: 'QuickQuote AI',
    subtitle: 'Get a realistic project estimate in ~5 minutes',
    welcomeMessage:
      "👋 Welcome to QuickQuote AI by WWG!\n\nWith 24 years of experience and 340+ delivered projects, we'll help you get a realistic estimate for your custom software project in about 5 minutes.\n\nYou'll receive a structured breakdown including:\n• Budget range (min–max)\n• Timeline range\n• Key phases & deliverables\n• Risks & assumptions\n• Suggested next steps\n\nI'll ask one question at a time. Ready? Just say 'Hi' or 'Let's begin'!",
  },
  n2n: {
    id: 'n2n',
    source: 'n2n',
    name: 'WWG End-to-End',
    subtitle: 'Full-cycle software development partnership',
    welcomeMessage:
      "👋 Welcome to WWG End-to-End!\n\nTrusted by 100+ companies worldwide, we manage the entire delivery process — from discovery and UX to development, QA, DevOps, and maintenance.\n\nI'll help match you with the right engagement model:\n• Fixed Scope Project\n• Dedicated Team\n• Time & Materials\n• Discovery / Audit First\n\nTell me about your project and we'll find the best approach. Just say 'Hi' to get started!",
  },
};

export function getServiceConfig(serviceId: string): ServiceConfig | undefined {
  return services[serviceId];
}

export default services;
